Controller = App.loadClass 'core::Angular/Controller'

class exports.StepController extends Controller

    constructor: (@scope, @transitions, @map) ->
        if not @scope.rx.fields_id?
            @scope.aborted = true
            return

        super(@scope, @transitions)


    setUpMap: () ->
        if not @map?
            return

        # Feature group to wrap up everything that goes on the
        # map during this process.
        @mapLayer = @map.createFeatureGroup()
        @map.add(@mapLayer)

        # When the scope for this controller is destroyed (meaning
        # that the controller is destroyed), remove the map layer
        # so that any map stuff we've done will not get stuck on the
        # map after leaving the process
        @scope.$on '$destroy', () =>
            @map.remove(@mapLayer)
